import { createTheme } from '@mui/material/styles';
import { basePortalThemeOptions } from './base-portal-theme-options';
import './type';

export const theme = createTheme(basePortalThemeOptions);
